module.exports = __webpack_public_path__ + "img/ceramic-artist.13871097.jpg";